module.exports = {
  props: {
    show: {
      type: Boolean,
      required: true,
      twoWay: true,
    },
    width: {
      type: Number,
      default: 300,
    },
    defaultTitle: {
      type: String,
    },
  },

  computed: {
    bodyModalOpen: function(){
      if(this.show) {
        var bd = document.getElementsByTagName('body')[0]
        bd.classList.add('modal-open')
        return true
      } else {
        var bd = document.getElementsByTagName('body')[0]
        bd.classList.remove('modal-open')
        return false
      }
    },
  },

}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/modal.vue
// module id = 141
// module chunks = 0